<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <SalabamLoginPage :service_title="service_title" :service_name="service_name"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import SalabamLoginPage from '@/components/salabam/SalabamLoginPage'

export default {
  name: 'SalabamVivamod',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Hotels.com", link : 'conv-salabam-vivamod' } ],

        // Nome welfarebit del servizio
        service_title : "Hotels.com",

        // Identificativo del servizio
        service_name : "vivamod"
    }
  },
  components: {
    PageTagline,
    SalabamLoginPage
  }
}
</script>

<style scoped></style>